import { Controller } from '@hotwired/stimulus';

// CSV アップロードのドラッグ&ドロップ + ファイル選択 UI (#1980)。
// hidden の file input に選択結果を反映し、選択状態のチップ表示・送信ボタンの
// 活性を制御する。実 input は accept=".csv" で残し、Cuprite の attach_file が
// 通常選択経路で動くようにする。
export default class extends Controller {
  static targets = ['input', 'dropzone', 'selected', 'fileName', 'fileSize', 'hint'];

  connect() {
    // 再描画 (Ajax バリデーション後など) で既にファイルがある場合に同期
    if (this.hasInputTarget && this.inputTarget.files.length > 0) {
      this.showFile(this.inputTarget.files[0]);
    }
  }

  browse(event) {
    event.preventDefault();
    this.inputTarget.click();
  }

  openDialog(event) {
    // 「ファイルを選択」ボタンは csv-drop の内側にあり、ボタン押下時の click は
    // browse と openDialog の両方に到達する。両方が input.click() を呼ぶと
    // ファイル選択ダイアログが2回開くため、ボタン由来の click はここで無視する
    // (browse が責任を持つ) (#2023)。
    if (event.target.closest('.csv-browse')) return;

    // ドロップゾーン全体クリックでもダイアログを開く (チップ表示中は無効)
    if (this.hasSelectedTarget && this.selectedTarget.classList.contains('is-shown')) return;

    this.inputTarget.click();
  }

  inputChanged() {
    if (this.inputTarget.files[0]) this.showFile(this.inputTarget.files[0]);
  }

  remove(event) {
    event.preventDefault();
    this.inputTarget.value = '';
    this.dropzoneTarget.classList.remove('is-hidden');
    this.selectedTarget.classList.remove('is-shown');
    this.toggleSubmit(false);
    if (this.hasHintTarget) this.hintTarget.classList.remove('is-hidden');
  }

  dragOver(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.add('is-dragging');
  }

  dragLeave(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove('is-dragging');
  }

  drop(event) {
    event.preventDefault();
    this.dropzoneTarget.classList.remove('is-dragging');
    const file = event.dataTransfer.files[0];
    if (!file) return;

    try {
      const dt = new DataTransfer();
      dt.items.add(file);
      this.inputTarget.files = dt.files;
    } catch (_) {
      // DataTransfer 非対応ブラウザでは input への反映を諦め、表示のみ更新
    }
    this.showFile(file);
  }

  showFile(file) {
    this.fileNameTarget.textContent = file.name;
    this.fileSizeTarget.textContent = `${(file.size / 1024).toFixed(1)} KB`;
    this.dropzoneTarget.classList.add('is-hidden');
    this.selectedTarget.classList.add('is-shown');
    this.toggleSubmit(true);
    if (this.hasHintTarget) this.hintTarget.classList.add('is-hidden');
  }

  toggleSubmit(enabled) {
    const submit = this.element.querySelector('[data-csv-dropzone-submit]');
    if (submit) submit.disabled = !enabled;
  }
}
